import { createReducer } from '@reduxjs/toolkit'
import { isEqual } from 'lodash'

import { StatusBannerData } from 'utils/types'

import * as actions from '../../actions/StatusBanner/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export interface StatusBannerReducerType {
  data: StatusBannerData[]
}

const INITIAL_STATE: StatusBannerReducerType = {
  data: []
}

const StatusBannerReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getSuccess, (state, action) => {
      // App polls this on an interval — only touch state when the
      // payload actually changed so subscribers don't re-render.
      if (!isEqual(state.data, action.payload.data)) {
        state.data = action.payload.data
      }
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})

export default StatusBannerReducer
